(function(){
  if (window.__txpInfiniteCollectionOnlyBtnV3) return;
  window.__txpInfiniteCollectionOnlyBtnV3 = true;

  function boot(){
    document.querySelectorAll('.txp-infinite-wrapper').forEach(initWrap);
  }

  function initWrap(wrap){
    if (!wrap || wrap.__txpInit) return;
    wrap.__txpInit = true;

    // Por si el HTML viejo quedó cacheado: remueve/hide loaders
    wrap.querySelectorAll('.txp-infinite-loader').forEach(function(n){
      n.hidden = true; n.style.display = 'none';
    });

    var state = wrap.querySelector('.txp-pagination-state');
    var btn = wrap.querySelector('.txp-load-more');
    var sentinel = wrap.querySelector('.txp-infinite-sentinel');

    var section = wrap.closest('.shopify-section') || document;
    var grid = section.querySelector('#product-grid') || document.querySelector('#product-grid');
    if (!state || !btn || !grid) return;

    var nextUrl = state.getAttribute('data-next-url') || '';
    var loading = false;

    function setLoading(on){
      btn.classList.toggle('is-loading', !!on);
      btn.disabled = !!on;
      var label = btn.querySelector('.txp-btn-label');
      if (!label) return;
      if (on){
        if (!btn.dataset._orig) btn.dataset._orig = label.textContent.trim();
        label.textContent = 'Cargando...';
      } else {
        label.textContent = btn.dataset._orig || 'Cargar más';
      }
    }

    async function load(){
      if (loading) return;
      if (!nextUrl){
        btn.style.display = 'none';
        if (sentinel) sentinel.style.display = 'none';
        return;
      }

      loading = true;
      setLoading(true);

      try{
        var res = await fetch(nextUrl, { headers: { 'X-Requested-With':'XMLHttpRequest' }});
        if (!res.ok) throw new Error('HTTP ' + res.status);
        var html = await res.text();
        var doc = new DOMParser().parseFromString(html, 'text/html');

        var nextGrid = doc.querySelector('#product-grid');
        if (nextGrid){
          var frag = document.createDocumentFragment();
          Array.from(nextGrid.children).forEach(function(n){ frag.appendChild(n); });
          grid.appendChild(frag);
        }

        var nextState = doc.querySelector('.txp-infinite-wrapper .txp-pagination-state');
        nextUrl = nextState ? (nextState.getAttribute('data-next-url') || '') : '';
        state.setAttribute('data-next-url', nextUrl);

        if (!nextUrl){
          btn.style.display = 'none';
          if (sentinel) sentinel.style.display = 'none';
        }
      } catch(e){
        console.warn('TXP infinite error', e);
      } finally {
        loading = false;
        setLoading(false);
      }
    }

    btn.addEventListener('click', function(e){ e.preventDefault(); load(); });

    // autoload (si querés quitarlo después, lo apagamos)
    if (sentinel && 'IntersectionObserver' in window){
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(en){ if (en.isIntersecting) load(); });
      }, { rootMargin: '600px 0px' });
      io.observe(sentinel);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', boot);
})();
